import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchObject } from '@/domains/communication/apis/statistic';

const useHistory = ({ queryParams = '' }) => {
  const _queryClient = useQueryClient();

  const { data: objectListData } = useQuery({
    queryKey: ['objectListData', queryParams],
    queryFn: () => fetchObject(queryParams),
    staleTime: 1000 * 60 * 1,
  });

  return {
    objectListData,
  };
};

export default useHistory;
